import React from "react";
import "./Sections.scss";

function Section3() {
  return (
    <section className="sections sections-marginBox">
      <p className="sections-title">WHAT HAPPENS WHEN INTEREST RATES GO UP?</p>
      <p className="sections-copy">
        Most homebuyers finance their purchase using a 30-year fixed-rate
        mortgage. Such a mortgage provides a hedge against inflation and offers
        the predictability of knowing that one’s monthly payments will stay the
        same for the lifetime of the loan.
      </p>
      <p className="sections-copy">
        Interest rates are expected to rise in 2022, but just how much of an
        impact would a small interest rate increase have on the total costs a
        borrower could expect to pay over three decades?
      </p>
      <p className="sections-copy">
        Use the interactive tool below to see how even a small change in
        interest rates can add or subtract thousands of dollars from the total
        costs of a 30-year loan.
      </p>
    </section>
  );
}

export default Section3;
